<script setup>
import {formatNumber} from "@/helpers/string";
import useMarkdown from "@/composables/useMarkdown";
import {getEcoLogo} from "@/helpers/logo";

defineProps(['startup']);

const md = useMarkdown();

function formateDateForNews(string) {
    const date = new Date(string);

    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
}
</script>

<template>
    <div class="matchmaking__content__inner">
        <div class="matchmaking__content__details">
            <ul class="matchmaking__overview">
                <li class="matchmaking__overview__name">
                    <a :href="`https://${startup.url_domain}`" target="_blank"><span>{{startup.url_domain }}</span></a>
                </li>
                <li v-if="startup.total_raised" class="matchmaking__overview__funding">
                    <span>{{ formatNumber(startup.total_raised) }} Raised</span>
                </li>
                <li v-if="startup.revenue_range" class="matchmaking__overview__income">
                    <span>{{ startup.revenue_range }} Annual Income</span>
                </li>
                <li v-if="startup.employees" class="matchmaking__overview__employees">
                    <span>{{ startup.employees }} Employees</span>
                </li>
                <li v-if="startup.location" class="matchmaking__overview__location">
                    <span>{{ startup.location }}</span>
                </li>
                <li v-if="startup.stage" class="matchmaking__overview__startups">
                    <span>{{ startup.stage }}</span>
                </li>
                <li v-if="startup.founded" class="matchmaking__overview__founded">
                    <span>Founded {{ startup.founded }}</span>
                </li>
            </ul>

            <div class="matchmaking__about">
                <h5 class="heading5 heading5--secondary mb-3">About {{startup.name}}:</h5>

                <p>{{ startup.description }}</p>

                <slot name="addSection"/>
            </div>
        </div>

        <div v-if="startup.ecosystem_details?.comment" class="card--need card--need--secondary">
            <div class="card--need__content">
                <figure class="card--need__figure">
                    <img style="max-width: 100px; max-height: 100px" :src="getEcoLogo(startup.ecosystem_details.logo)" :alt="startup.ecosystem_details.name" class="matchmaking__textarea__logo"/>
                </figure>

                <div class="card--need__inner">
                    <h5 class="heading5 heading5--secondary">{{ startup.ecosystem_details.user_name}}, <b>{{ startup.ecosystem_details.name }}</b>:</h5>
                    <p class="mb-0"><i v-html="startup.ecosystem_details.comment"/></p>
                </div>
            </div>
        </div>

        <div v-if="startup.features?.length" class="card-headline">
            <header class="card-headline__header">Features</header>

            <div class="card-headline__content">
                <div v-html="md.render(startup.features)"/>
            </div>
        </div>

        <div v-if="startup.news.length" class="card-headline">
            <header class="card-headline__header">News</header>

            <div class="card-headline__content">
                <div
                    v-for="news in startup.news"
                    :key="news.id"
                    class="card card--bordered"
                >
                    <div>
                        <a :href="`https://${news.domain}`" class="card-headline__url" target="_blank">{{ news.domain }}</a>

                        <h6 class="heading6">
                            <a :href="news.url" target="_blank">{{ news.title }}</a>
                        </h6>

                        <time v-if="news.posted_on" class="card-headline__time">
                            {{formateDateForNews(news.posted_on) }}
                        </time>
                    </div>

                    <figure v-if="news.image_url" class="card-headline__img">
                        <img :src="news.image_url" style="height: 100%" alt="">
                    </figure>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
